import produce from 'immer';
import { sensorsGPSDashboardActions } from './actions';

// const endTime = new Date();
// const endMinute = Math.floor(endTime.getMinutes() / 5) * 5;
// endTime.setMinutes(endMinute);
// const startTime = new Date(endTime.getTime() - 30 * 24 * 60 * 60 * 1000);

const initialState = {
  loading: false,
  sensorIdSelected: null,
  sensorSelected: null,
  sensors: [],
  sensorsGPSHistory: [],
  type: '',
  // // Time range, default is ~1 month advancedZ
  // lastGPSParams: {
  //   endTime: endTime, // data type: datetime
  //   startTime: startTime, // data type: datetime
  // },
};

const GPSDashboard = (state = initialState, action) => {
  const { type: actionType, payload } = action;
  switch (action.type) {
    // case sensorsGPSDashboardActions.SET_LAST_GPS_PARAMS:
    //   return produce(state, (draft) => {
    //     draft.lastGPSParams.startTime = payload?.startTime;
    //     draft.lastGPSParams.endTime = payload?.endTime;
    //     draft.type = actionType;
    //   });
    case sensorsGPSDashboardActions.TOGGLE_SENS0R_SELECTED:
      const crrIdSelected = state.sensorIdSelected;
      const idSelected = payload?.id;
      const isShowSelected = crrIdSelected !== idSelected;
      return produce(state, (draft) => {
        draft.sensorIdSelected = isShowSelected ? idSelected : null;
        draft.sensorSelected = isShowSelected ? payload : null;
        draft.type = actionType;
      });

    case sensorsGPSDashboardActions.GET_LAST_DEVICES_GPS:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.loading = true;
        // draft.sensors = [];
      });
    case sensorsGPSDashboardActions.GET_LAST_DEVICES_GPS_SUCCESS:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.loading = false;
        draft.sensors = payload;
      });
    case sensorsGPSDashboardActions.GET_LAST_DEVICES_GPS_ERROR:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.loading = false;
        draft.sensors = [];
      });
    case sensorsGPSDashboardActions.GET_SENSORS_GPS_HISTORY:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.loading = true;
        // draft.sensors = [];
      });
    case sensorsGPSDashboardActions.GET_SENSORS_GPS_HISTORY_SUCCESS:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.loading = false;
        draft.sensorsGPSHistory = payload;
      });
    case sensorsGPSDashboardActions.GET_SENSORS_GPS_HISTORY_ERROR:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.loading = false;
        draft.sensorsGPSHistory = [];
      });
    default:
      return state;
  }
};

export default GPSDashboard;
